module.exports = __webpack_public_path__ + "static/img/77021D_R_02_20170816_LC.13fbe84.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/77021D_R_02_20170816_LC.png
// module id = +A13
// module chunks = 0